(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;

  var content = drawer.querySelector('[data-cart-drawer-content]');
  var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  var empty = drawer.querySelector('[data-cart-drawer-empty]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var note = drawer.querySelector('[data-cart-drawer-note]');
  var live = drawer.querySelector('[data-cart-drawer-live]');
  var lastTrigger = null;
  var currentCart = null;
  var noteTimer = null;

  function endpoint(name, fallback) {
    return drawer.dataset[name] || fallback;
  }

  function money(cents) {
    var currency = drawer.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function icon(name) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    svg.setAttribute('class', 'ico');
    svg.setAttribute('aria-hidden', 'true');
    use.setAttribute('href', '#ph-' + name);
    svg.appendChild(use);
    return svg;
  }

  function announce(message) {
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 20);
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-item-word]').forEach(function (node) {
      node.textContent = count === 1 ? 'item' : 'items';
    });
    var countLabel = drawer.querySelector('[data-cart-drawer-count]');
    if (countLabel) {
      countLabel.textContent = count;
      countLabel.hidden = count === 0;
    }
  }

  /* A subscription of enough bottles ships free whatever the cart total (the
     store's "Subscription Free Shipping" discount), so it fills the bar too. */
  function subscriptionShipsFree(cart) {
    return cart.items.some(function (item) {
      return item.selling_plan_allocation && bottlesOf({ title: item.variant_title }) >= sub.freeShipFrom;
    });
  }

  function updateShipping(cart) {
    var threshold = Number(drawer.dataset.freeShippingThreshold || 7000);
    var free = subscriptionShipsFree(cart);
    var progress = free ? 100 : Math.min(100, Math.round((cart.total_price / threshold) * 100));
    var remaining = free ? 0 : Math.max(0, threshold - cart.total_price);
    var unlocked = remaining === 0;
    var shipping = drawer.querySelector('[data-cart-drawer-shipping]');
    var title = drawer.querySelector('[data-cart-drawer-shipping-title]');
    var copy = drawer.querySelector('[data-cart-drawer-shipping-copy]');
    var perk = drawer.querySelector('[data-cart-drawer-shipping-perk]');
    var unlockedNote = drawer.querySelector('[data-cart-drawer-unlocked-note]');
    var bar = drawer.querySelector('[data-cart-drawer-progress]');
    var track = bar.parentElement;
    title.textContent = unlocked ? 'All offers unlocked' : 'Free shipping progress';
    copy.textContent = unlocked ? '' : 'You’re ' + money(remaining) + ' away';
    copy.hidden = unlocked;
    perk.hidden = !unlocked;
    perk.parentElement.hidden = !unlocked;
    unlockedNote.hidden = !unlocked;
    shipping.classList.toggle('is-unlocked', unlocked);
    bar.style.width = progress + '%';
    track.setAttribute('aria-valuenow', String(progress));
    track.setAttribute('aria-valuetext', unlocked ? 'Free U.S. shipping unlocked' : progress + '% toward free U.S. shipping');
  }

  function button(label, className, handler) {
    var control = document.createElement('button');
    control.type = 'button';
    control.className = className;
    control.setAttribute('aria-label', label);
    control.textContent = label.indexOf('Increase') === 0 ? '+' : label.indexOf('Decrease') === 0 ? '−' : label;
    control.addEventListener('click', handler);
    return control;
  }

  function renderLine(item) {
    var row = document.createElement('article');
    row.className = 'cart-drawer-line';

    var media = document.createElement('a');
    media.className = 'cart-drawer-line-media';
    media.href = item.url;
    media.setAttribute('aria-label', 'View ' + item.product_title);
    if (item.image) {
      var image = document.createElement('img');
      image.src = item.image;
      image.alt = item.product_title;
      image.width = 224;
      image.height = 224;
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.appendChild(icon('package'));
    }

    var copy = document.createElement('div');
    copy.className = 'cart-drawer-line-copy';
    var title = document.createElement('a');
    title.className = 'cart-drawer-line-title';
    title.href = item.url;
    title.textContent = item.product_title;
    copy.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      var variant = document.createElement('p');
      variant.className = 'cart-drawer-line-variant';
      variant.textContent = item.variant_title;
      copy.appendChild(variant);
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      var plan = document.createElement('p');
      plan.className = 'cart-drawer-line-plan';
      /* The app stores the plan name HTML-escaped ("Subscribe &amp; Save, Every 3
         months"): decode it, then show group and interval as "A · B". */
      var planName = new DOMParser().parseFromString(item.selling_plan_allocation.selling_plan.name, 'text/html').documentElement.textContent;
      plan.textContent = planName.replace(/,\s*/, ' · ');
      copy.appendChild(plan);
    }

    var price = document.createElement('p');
    price.className = 'cart-drawer-line-price';
    price.textContent = money(item.final_line_price);
    copy.appendChild(price);

    var controls = document.createElement('div');
    controls.className = 'cart-drawer-line-controls';
    var qty = document.createElement('div');
    qty.className = 'cart-drawer-qty';
    qty.setAttribute('aria-label', 'Quantity for ' + item.product_title);
    qty.appendChild(button('Decrease ' + item.product_title + ' quantity', '', function () { change(item.key, Math.max(0, item.quantity - 1)); }));
    var number = document.createElement('span');
    number.textContent = item.quantity;
    number.setAttribute('aria-live', 'polite');
    qty.appendChild(number);
    qty.appendChild(button('Increase ' + item.product_title + ' quantity', '', function () { change(item.key, item.quantity + 1); }));
    controls.appendChild(qty);
    copy.appendChild(controls);

    var remove = button('Remove ' + item.product_title, 'cart-drawer-line-delete', function () { change(item.key, 0); });
    remove.textContent = '';
    remove.appendChild(icon('trash'));
    row.appendChild(media);
    row.appendChild(copy);
    row.appendChild(remove);
    return row;
  }

  function render(cart) {
    currentCart = cart;
    itemsContainer.replaceChildren();
    content.setAttribute('aria-busy', 'false');
    updateCounts(cart.item_count);
    updateShipping(cart);
    drawer.querySelector('[data-cart-drawer-total]').textContent = money(cart.total_price);
    note.value = cart.note || '';

    if (!cart.items.length) {
      content.hidden = true;
      footer.hidden = true;
      empty.hidden = false;
      return;
    }

    content.hidden = false;
    footer.hidden = false;
    empty.hidden = true;
    cart.items.forEach(function (item) {
      var row = renderLine(item);
      itemsContainer.appendChild(row);
      planPanel(row, item);
    });
  }

  /* ── subscription plan box, Change editor and bundle offer ───────────
     Client request (2026-09-27), modelled on NuBest's cart. Everything is
     read from /products/<handle>.js: the plan variants (1/3/6-bottle, each
     with its selling plans) and the one-time variant. A change is made by
     adding the new line first and only then removing the old one, so a
     failed add never leaves the cart without the item. Renewal prices stay
     hidden until the theme setting says otherwise (the subscription app has
     not yet been seen to charge them). */
  var sub = {
    editor: drawer.dataset.subEditor !== 'false',
    upsell: drawer.dataset.subUpsell !== 'false',
    renewal: drawer.dataset.subRenewal === 'true',
    shipping: drawer.dataset.subShowShipping === 'true',
    freeShipFrom: Number(drawer.dataset.subFreeShipFrom || 1),
    reassure: drawer.dataset.subReassure || '',
    packs: (drawer.dataset.oncePacks || '1,3,6').split(',').map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { return n > 0; }),
    renewalOff: (drawer.dataset.subRenewalOff || '').split(',').reduce(function (map, pair) {
      var bits = pair.split(':');
      if (bits.length === 2) map[parseInt(bits[0], 10)] = parseFloat(bits[1]);
      return map;
    }, {})
  };
  var products = {};
  var SHIP_PROP = 'Auto-ship every';

  function decode(text) {
    return new DOMParser().parseFromString(String(text || ''), 'text/html').documentElement.textContent;
  }

  function loadProduct(handle) {
    if (!products[handle]) {
      products[handle] = request((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js')
        .then(model).catch(function () { return null; });
    }
    return products[handle];
  }

  function bottlesOf(variant) {
    var match = /(\d+)\s*-?\s*bottle/i.exec(variant.title || '');
    return match ? parseInt(match[1], 10) : 1;
  }

  function model(product) {
    var planNames = {};
    (product.selling_plan_groups || []).forEach(function (group) {
      group.selling_plans.forEach(function (plan) { planNames[plan.id] = decode(plan.name); });
    });
    var plans = [];
    var once = null;
    product.variants.forEach(function (variant) {
      if (!variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
        if (!once) once = variant;
        return;
      }
      var intervals = variant.selling_plan_allocations.map(function (alloc) {
        var name = planNames[alloc.selling_plan_id] || '';
        return { id: alloc.selling_plan_id, label: name.split('Every ').pop().trim(), price: alloc.price };
      }).sort(function (a, b) { return (parseFloat(a.label) || 0) - (parseFloat(b.label) || 0); });
      plans.push({ variant: variant, bottles: bottlesOf(variant), intervals: intervals });
    });
    plans.sort(function (a, b) { return a.bottles - b.bottles; });
    return plans.length ? { plans: plans, once: once } : null;
  }

  /* The interval a bundle opens on: one month per bottle, as on the product page. */
  function defaultInterval(plan) {
    var want = plan.bottles + ' month';
    return plan.intervals.filter(function (i) { return i.label.indexOf(want) === 0; })[0] || plan.intervals[0];
  }

  function saving(variant) {
    var was = variant.compare_at_price || 0;
    return was > variant.price ? Math.round((was - variant.price) / was * 100) : 0;
  }

  function renewalPrice(plan) {
    var off = sub.renewalOff[plan.bottles];
    var base = plan.variant.compare_at_price || plan.variant.price;
    return off ? Math.round(base * (100 - off) / 100) : null;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function linkButton(label, handler) {
    var b = el('button', 'cds-link', label);
    b.type = 'button';
    b.addEventListener('click', handler);
    return b;
  }

  function bottlesLabel(n) { return n + (n === 1 ? ' bottle' : ' bottles'); }

  function planPanel(row, item) {
    if (!sub.editor || !item.handle) return;
    var slot = el('div', 'cds');
    row.appendChild(slot);
    loadProduct(item.handle).then(function (data) {
      if (!data || !slot.isConnected) return;
      var state = currentState(data, item);
      if (!state) return;
      /* The box states the plan, so the plain plan line above it would repeat it. */
      var planLine = row.querySelector('.cart-drawer-line-plan');
      if (planLine) planLine.hidden = true;
      showSummary(slot, data, item, state);
    });
  }

  function currentState(data, item) {
    if (item.selling_plan_allocation) {
      var planId = item.selling_plan_allocation.selling_plan.id;
      var plan = data.plans.filter(function (p) { return p.variant.id === item.variant_id; })[0];
      if (!plan) return null;
      var interval = plan.intervals.filter(function (i) { return i.id === planId; })[0] || defaultInterval(plan);
      return { mode: 'sub', plan: plan, interval: interval, quantity: item.quantity };
    }
    if (data.once && data.once.id === item.variant_id) {
      return { mode: 'once', bottles: item.quantity, quantity: item.quantity };
    }
    return null;
  }

  function showSummary(slot, data, item, state) {
    slot.replaceChildren();
    var box = el('div', 'cds-box');
    var head = el('div', 'cds-box-head');
    head.appendChild(icon(state.mode === 'sub' ? 'arrows-clockwise' : 'package'));
    var words = el('div', 'cds-box-words');
    if (state.mode === 'sub') {
      words.appendChild(el('strong', '', 'Subscribe & Save'));
      words.appendChild(el('span', '', 'Delivered every ' + state.interval.label));
    } else {
      words.appendChild(el('strong', '', 'One-time purchase'));
      words.appendChild(el('span', '', bottlesLabel(state.bottles) + ' · no renewal savings'));
    }
    head.appendChild(words);
    head.appendChild(linkButton('Change', function () { showEditor(slot, data, item, state); }));
    box.appendChild(head);

    if (state.mode === 'sub') {
      var meta = [];
      var renew = sub.renewal ? renewalPrice(state.plan) : null;
      if (renew) meta.push('Renews at ' + money(renew * state.quantity) + ' every ' + state.interval.label);
      if (sub.shipping) meta.push(state.plan.bottles >= sub.freeShipFrom ? 'Free U.S. shipping' : 'Shipping fees apply');
      if (meta.length) box.appendChild(el('p', 'cds-meta', meta.join(' · ')));
    }
    slot.appendChild(box);

    if (state.mode === 'sub' && sub.upsell) upsell(slot, data, item, state);
    if (state.mode === 'sub' && sub.reassure) {
      var calm = el('p', 'cds-reassure');
      calm.appendChild(icon('seal-check'));
      calm.appendChild(document.createTextNode(sub.reassure));
      slot.appendChild(calm);
    }
  }

  function upsell(slot, data, item, state) {
    var bigger = data.plans.filter(function (p) { return p.bottles > state.plan.bottles; })[0];
    var key = 'groeUpsellHidden:' + item.key;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (!bigger || dismissed || !bigger.variant.available) return;

    var off = saving(bigger.variant);
    var box = el('div', 'cds-up');
    var head = el('div', 'cds-up-head');
    head.appendChild(el('strong', '', 'Get ' + bottlesLabel(bigger.bottles) + (off ? ' and save ' + off + '%' : '')));
    var body = el('div', 'cds-up-body');
    body.hidden = true;
    var toggle = linkButton('See details', function () {
      body.hidden = !body.hidden;
      toggle.textContent = body.hidden ? 'See details' : 'Hide';
      toggle.setAttribute('aria-expanded', String(!body.hidden));
    });
    toggle.setAttribute('aria-expanded', 'false');
    head.appendChild(toggle);
    box.appendChild(head);

    var target = defaultInterval(bigger);
    var today = bigger.variant.price * state.quantity;
    var list = el('ul', 'cds-up-list');
    function point(strong, rest) {
      var li = el('li');
      li.appendChild(icon('check'));
      var span = el('span');
      span.appendChild(el('b', '', strong));
      span.appendChild(document.createTextNode(rest));
      li.appendChild(span);
      list.appendChild(li);
    }
    var forWhat = state.quantity > 1 ? state.quantity + ' × ' + bottlesLabel(bigger.bottles) : bottlesLabel(bigger.bottles);
    point(money(today) + ' today', ' for ' + forWhat + ', +' + money(Math.max(0, today - item.final_line_price)) + ' on this order');
    var renew = sub.renewal ? renewalPrice(bigger) : null;
    if (renew) point('Refills at ' + money(renew * state.quantity), ' every ' + target.label + ', ' + sub.renewalOff[bigger.bottles] + '% off');
    if (target.label !== state.interval.label) point('One delivery every ' + target.label, ' instead of every ' + state.interval.label);
    if (sub.shipping && bigger.bottles >= sub.freeShipFrom && state.plan.bottles < sub.freeShipFrom) point('Free U.S. shipping', ' on every delivery');
    body.appendChild(list);

    var actions = el('div', 'cds-actions');
    var go = el('button', 'btn btn-outline cds-go', 'Switch to ' + bottlesLabel(bigger.bottles));
    go.type = 'button';
    go.addEventListener('click', function () {
      swap(item, { mode: 'sub', plan: bigger, interval: target, quantity: state.quantity }, go);
    });
    actions.appendChild(go);
    actions.appendChild(linkButton('Not now', function () {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      box.remove();
    }));
    body.appendChild(actions);
    box.appendChild(body);
    slot.appendChild(box);
  }

  function showEditor(slot, data, item, start) {
    var draft = {
      mode: start.mode,
      plan: start.mode === 'sub' ? start.plan : (data.plans.filter(function (p) { return p.bottles === start.bottles; })[0] || data.plans[0]),
      interval: start.mode === 'sub' ? start.interval : null,
      bottles: start.mode === 'once' ? start.bottles : start.plan.bottles
    };
    if (!draft.interval) draft.interval = defaultInterval(draft.plan);

    slot.replaceChildren();
    var box = el('div', 'cds-editor');
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Change plan for ' + item.product_title);
    slot.appendChild(box);

    function draw() {
      box.replaceChildren();
      var tabs = el('div', 'cds-tabs');
      [['sub', 'Subscribe & Save'], ['once', 'One-time purchase']].forEach(function (pair) {
        if (pair[0] === 'once' && (!data.once || (!data.once.available && start.mode !== 'once'))) return;
        var t = el('button', 'cds-tab', pair[1]);
        t.type = 'button';
        t.setAttribute('aria-pressed', String(draft.mode === pair[0]));
        t.addEventListener('click', function () {
          if (draft.mode === pair[0]) return;
          draft.mode = pair[0];
          if (draft.mode === 'sub') {
            draft.plan = data.plans.filter(function (p) { return p.bottles === draft.bottles; })[0] || draft.plan;
            draft.interval = defaultInterval(draft.plan);
          } else {
            var total = draft.plan.bottles * (start.mode === 'sub' ? start.quantity : 1);
            draft.bottles = sub.packs.indexOf(total) >= 0 ? total
              : sub.packs.indexOf(draft.plan.bottles) >= 0 ? draft.plan.bottles : sub.packs[0];
          }
          draw();
        });
        tabs.appendChild(t);
      });
      if (tabs.children.length > 1) box.appendChild(tabs);

      var fieldset = el('fieldset', 'cds-options');
      fieldset.appendChild(el('legend', 'sr-only', draft.mode === 'sub' ? 'Bundle size' : 'Quantity'));
      var options = draft.mode === 'sub'
        ? data.plans.map(function (p) {
            return { key: p.bottles, name: bottlesLabel(p.bottles), off: saving(p.variant), price: p.variant.price,
                     was: p.variant.compare_at_price, unit: Math.round(p.variant.price / p.bottles), available: p.variant.available, plan: p };
          })
        : sub.packs.map(function (n) {
            return { key: n, name: bottlesLabel(n), off: 0, price: data.once.price * n, was: 0,
                     unit: data.once.price, available: data.once.available };
          });
      options.forEach(function (o) {
        var label = el('label', 'cds-option');
        var input = el('input');
        input.type = 'radio';
        input.name = 'cds-' + item.key;
        input.checked = draft.mode === 'sub' ? draft.plan.bottles === o.key : draft.bottles === o.key;
        input.disabled = !o.available;
        input.addEventListener('change', function () {
          if (draft.mode === 'sub') {
            draft.plan = o.plan;
            draft.interval = defaultInterval(o.plan);
          }
          draft.bottles = o.key;
          draw();
        });
        label.appendChild(input);
        var copy = el('span', 'cds-option-copy');
        var name = el('span', 'cds-option-name', o.name);
        if (o.off) name.appendChild(el('em', 'cds-save', 'Save ' + o.off + '%'));
        copy.appendChild(name);
        copy.appendChild(el('span', 'cds-option-unit', money(o.unit) + '/bottle'));
        label.appendChild(copy);
        var price = el('span', 'cds-option-price');
        price.appendChild(el('b', '', money(o.price)));
        if (o.was > o.price) price.appendChild(el('s', '', money(o.was)));
        label.appendChild(price);
        fieldset.appendChild(label);
      });
      box.appendChild(fieldset);

      var qty = draft.mode === 'sub' ? (start.mode === 'sub' ? start.quantity : 1) : 1;
      var today = draft.mode === 'sub' ? draft.plan.variant.price * qty : data.once.price * draft.bottles;

      if (draft.mode === 'sub') {
        var every = el('label', 'cds-every');
        every.appendChild(icon('clock'));
        every.appendChild(el('span', '', 'Delivered every'));
        var select = el('select', 'cds-every-select');
        draft.plan.intervals.forEach(function (i) {
          var opt = el('option', '', i.label);
          opt.value = String(i.id);
          opt.selected = i.id === draft.interval.id;
          select.appendChild(opt);
        });
        select.addEventListener('change', function () {
          draft.interval = draft.plan.intervals.filter(function (i) { return String(i.id) === select.value; })[0];
          draw();
        });
        every.appendChild(select);
        box.appendChild(every);
      }

      var summary = el('div', 'cds-today');
      summary.appendChild(el('strong', '', 'Price today ' + money(today)));
      var renew = draft.mode === 'sub' && sub.renewal ? renewalPrice(draft.plan) : null;
      if (renew) summary.appendChild(el('span', '', 'Renews at ' + money(renew * qty) + ' every ' + draft.interval.label));
      box.appendChild(summary);

      var actions = el('div', 'cds-actions');
      var done = el('button', 'btn btn-primary cds-done', 'Done');
      done.type = 'button';
      var picked = fieldset.querySelector('input:checked');
      done.disabled = !picked || picked.disabled;
      done.addEventListener('click', function () {
        var target = draft.mode === 'sub'
          ? { mode: 'sub', plan: draft.plan, interval: draft.interval, quantity: qty }
          : { mode: 'once', variant: data.once, quantity: draft.bottles };
        var same = target.mode === start.mode && (target.mode === 'sub'
          ? target.plan === start.plan && target.interval.id === start.interval.id && target.quantity === start.quantity
          : target.quantity === start.quantity);
        if (same) { showSummary(slot, data, item, start); return; }
        swap(item, target, done);
      });
      actions.appendChild(done);
      actions.appendChild(linkButton('Cancel', function () { showSummary(slot, data, item, start); }));
      box.appendChild(actions);
    }
    draw();
    var first = box.querySelector('.cds-tab[aria-pressed="true"], input:checked');
    if (first) first.focus();
  }

  function swap(item, target, control) {
    var line = target.mode === 'sub'
      ? { id: target.plan.variant.id, quantity: target.quantity, selling_plan: target.interval.id, properties: {} }
      : { id: target.variant.id, quantity: target.quantity };
    if (target.mode === 'sub') line.properties[SHIP_PROP] = target.interval.label;
    if (control) control.disabled = true;
    content.setAttribute('aria-busy', 'true');
    request(endpoint('cartAddUrl', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function () {
      return request(endpoint('cartChangeUrl', '/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }).then(function (cart) {
      render(cart);
      announce('Plan updated.');
    }).catch(function (error) {
      if (control) control.disabled = false;
      content.setAttribute('aria-busy', 'false');
      announce(error.message);
      refresh();
    });
  }

  function request(url, options) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, options || {})).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (body) {
        throw new Error(body.description || body.message || 'Cart could not be updated.');
      });
      return response.json();
    });
  }

  function refresh() {
    content.setAttribute('aria-busy', 'true');
    return request(endpoint('cartUrl', '/cart') + '.js').then(render).catch(function (error) {
      content.setAttribute('aria-busy', 'false');
      announce(error.message);
    });
  }

  function change(key, quantity) {
    content.setAttribute('aria-busy', 'true');
    request(endpoint('cartChangeUrl', '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      render(cart);
      announce(quantity === 0 ? 'Item removed from cart.' : 'Cart quantity updated.');
    }).catch(function (error) {
      content.setAttribute('aria-busy', 'false');
      announce(error.message);
    });
  }

  function saveNote() {
    window.clearTimeout(noteTimer);
    if (!currentCart || note.value === (currentCart.note || '')) return Promise.resolve();
    return request(endpoint('cartUpdateUrl', '/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).then(function (cart) {
      currentCart = cart;
      announce('Order note saved.');
    }).catch(function (error) { announce(error.message); });
  }

  function open(trigger) {
    lastTrigger = trigger || document.activeElement;
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('cart-drawer-open');
    drawer.querySelector('[data-cart-drawer-close]').focus();
    refresh();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-drawer-trigger]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (control) {
    control.addEventListener('click', function () { drawer.close(); });
  });
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) drawer.close();
  });
  drawer.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.open) {
      event.preventDefault();
      drawer.close();
    }
  });
  drawer.addEventListener('close', function () {
    document.body.classList.remove('cart-drawer-open');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
  });
  note.addEventListener('input', function () {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(saveNote, 700);
  });
  note.addEventListener('blur', saveNote);
  drawer.querySelector('[data-cart-drawer-checkout-form]').addEventListener('submit', function (event) {
    if (!currentCart || note.value === (currentCart.note || '')) return;
    event.preventDefault();
    var form = event.currentTarget;
    saveNote().then(function () { form.submit(); });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action || form.dataset.noCartDrawer !== undefined) return;
    var addUrl = endpoint('cartAddUrl', '/cart/add');
    if (new URL(form.action, window.location.href).pathname !== new URL(addUrl, window.location.href).pathname) return;
    event.preventDefault();
    var submitter = event.submitter;
    if (submitter) submitter.disabled = true;
    fetch(form.action, {
      method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'This item could not be added.'); });
      return response.json();
    }).then(function () {
      open(submitter || form);
      announce('Item added to cart.');
    }).catch(function (error) {
      announce(error.message);
      if (!drawer.open) open(submitter || form);
    }).finally(function () {
      if (submitter) submitter.disabled = false;
    });
  });
})();
